import {hideModal, showModal} from '../../../shared/ui/modal.util';
import {BaseController} from '../../../shared/basecontroller.controller';
import EVENTS from '@shared/events';

class FileListController extends BaseController {

  constructor(ProfileStore, HttpService, SessionService, $scope, FormService, AppService, $timeout, $sce, $translate) {
    'ngInject';

    super(AppService);

    this.$scope = $scope;
    this.$scope.renderingFile = false;
    this.$scope.filesToUpload = [];
    this.ProfileStore = ProfileStore;
    this.HttpService = HttpService;
    this.SessionService = SessionService;
    this.FormService = FormService;
    this.$timeout = $timeout;
    this.$sce = $sce;
    this.$translate = $translate;
    this.fileCount = 0;

    this.$scope.$on('fileRendered', (event, file) => {
      $('.modal-body').removeClass('ng-hide');
      $('.modal-body img').removeClass("hidden");
      this.$scope.renderingFile = false;
      if(file.ext.toLowerCase() === 'pdf') {
        file.previewLink = '/assets/images/pdf_icon.svg';
      }else if(['doc', 'docx'].indexOf(file.ext.toLowerCase()) >= 0){
        file.previewLink = '/assets/images/docs_icon.svg';
      }else{
        file.previewLink = file.downloadLink;
      }
    });

    this.$scope.$on('fileSelected', (event, file) => {
      this.$scope.renderingFile = true;
      this.$scope.selectedFile = file;
      this.$scope.isImage = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'bmp'].indexOf(file.ext.toLowerCase()) >= 0;
      if(typeof file.fileUri === 'undefined') {
       if (file.storage === 'S3') {
          this.HttpService.get('/' + this.SessionService.getLocale() + '/profile/file/uri/' + file.filename).then((uri) => {
            this.$scope.selectedFile.fileUri = uri;
            this.$scope.$emit('renderFile');
          });
        } else {
          this.$scope.selectedFile.fileUri = '/' + this.SessionService.getLocale() + '/profile/file/' + file.filename;
          this.$scope.$emit('renderFile');
        }
      }else{
        this.$scope.$emit('renderFile');
      }
      showModal('kycFileModal');
      $('.modal-backdrop').hide();
      $('#kyc-files').show();
    });

    this.$scope.$on('renderFile', () => {
      this.renderFile(this.$scope.selectedFile);
    });

    this.$scope.$on('reloadFiles', () => {
      this.reloadFiles();
    });
  }

  $onInit() {
    this.$scope.$emit('reloadFiles');
    this.addListener(EVENTS.KYC_FILE_UPLOADED, event => this.reloadFiles());
    this.addListener(EVENTS.KYC_FILE_DELETED, event => this.reloadFiles());

    this.$timeout(() => {
      let uploadField = document.getElementById("upload-input");

      let self = this;
      uploadField.onchange = function() {
        let hasError = false;
        angular.forEach(this.files, function(file, key){
          if(hasError){
            return;
          }
          let ext = file.name.split('.').pop().toLowerCase();
          if(file.size > 20971520){
            $(".kyc-up .error-val").removeClass("hidden");
            $(".kyc-up .error-ext").addClass("hidden");
            hasError = true;
          } else if($.inArray(ext, ['gif','png','jpg','jpeg','docx','pdf','doc']) == -1) {
            $(".kyc-up .error-ext").removeClass("hidden");
            $(".kyc-up .error-val").addClass("hidden");
            hasError = true;
          }
        });
        if(hasError){
          this.value = "";
          $(".kyc-up .reset-div").removeClass("hidden");
          $(".kyc-up .file-count, .kyc-up .file-uploading").addClass("hidden");
          $(".kyc-upload")[0].reset();
        }else{
          self.fileCount = this.files.length;
          $(".kyc-up .file-count").removeClass("hidden");
          $(".kyc-up .reset-div, .kyc-up .file-uploading").addClass("hidden");
          $(".kyc-up .error-ext").addClass("hidden");
          $(".kyc-up .error-val").addClass("hidden");
        }
      };

    });
  }

  reloadFiles() {
    $(".kyc-up .reset-div").removeClass("hidden");
    $(".kyc-up .file-count, .kyc-up .file-uploading").addClass("hidden");
    $(".kyc-upload")[0].reset();

    this.$scope.uploadSuccessful = false;
    this.HttpService.get('/' + this.SessionService.getLocale() + '/profile/files').then((files) => {
      this.$scope.files = files;
    });
  }

  deleteFile() {
    let file = this.$scope.selectedFile;
    this.HttpService.post('/' + this.SessionService.getLocale() + '/profile/file/' + file.filename + '/delete').then((response) =>{
      this.$scope.selectedFile = null;
      this.$scope.isImage = false;

      this.closeModals();
      // this.broadcast(EVENTS.KYC_FILE_DELETED);
      this.$scope.$emit('reloadFiles');
    });

  }

  uploadFiles() {

    if (!this.$scope.filesToUpload || this.$scope.filesToUpload.length < 1 ) {return;}

    this.FormService.isSubmitting.next(true);

    const fd = new FormData();
    if (this.$scope.filesToUpload.length > 1) {
      Array.from(this.$scope.filesToUpload).forEach(elem => { 
        fd.append('file[files][]', elem);
        $(".kyc-up .file-uploading").removeClass("hidden");
        $(".kyc-up .reset-div, .kyc-up .file-count").addClass("hidden");
        $(".kyc-upload")[0].reset();
      });
    }else{
      fd.append('file[files][]', this.$scope.filesToUpload[0]);
      $(".kyc-up .file-uploading").removeClass("hidden");
      $(".kyc-up .reset-div, .kyc-up .file-count").addClass("hidden");
      $(".kyc-upload")[0].reset();
    }

    this.HttpService.post('/' + this.SessionService.getLocale() + '/profile/files', fd, 'json', {
      'Content-Type': undefined
    }).then(() => {

      this.FormService.isSubmitting.next(false);
      this.broadcast(EVENTS.KYC_FILE_UPLOADED);
      this.$scope.uploadSuccessful = true;
      this.$scope.filesToUpload = [];
      setTimeout(()=>{
          this.$scope.$emit('reloadFiles');
        }, 3000);

    }).catch((errors) => {
      //show errors
      this.FormService.isSubmitting.next(false);
    });
  }

  renderFile(file) {
    if(typeof file.downloadLink === 'undefined'){
      if (file.storage === 'S3') {
        this.HttpService.$http.get(file.fileUri, {responseType: 'arraybuffer'}).then((s3data) => {
          var fileObj = new Blob([s3data], {type: 'application/binary'});
          file.downloadLink = this.$sce.trustAsResourceUrl(URL.createObjectURL(fileObj));
          if(this.$scope.isImage){
            file.previewLink = file.downloadLink;
          }
          this.$scope.$emit('fileRendered', this.$scope.selectedFile);
        });
      }else{
        this.HttpService.get(file.fileUri, 'arraybuffer').then((response) => {
          var fileObj = new Blob([response], {type: 'application/binary'});
          file.downloadLink = this.$sce.trustAsResourceUrl(URL.createObjectURL(fileObj));
          if(this.$scope.isImage){
            file.previewLink = file.downloadLink;
          }
          this.$scope.$emit('fileRendered', this.$scope.selectedFile);
        });
      }
    }else{
      this.$scope.$emit('fileRendered', this.$scope.selectedFile);
    }
  }

  showDeleteModal(){
    showModal('kycDelete');
    $('.modal-backdrop').hide();
    $('#kyc-files').show();
  }

  closeModals(){
    hideModal('kycDelete');
    hideModal('kycFileModal');
    $('#kyc-files').hide();
  }

  closeModalsOutside() {
     $('#kyc-files').fadeOut(300);
     hideModal('kycFileModal');
  }

  selectFile(file) {
    this.$scope.$emit('fileSelected', file);
  }

  closeButton(){
    $('#kyc-files').hide();
    $('.modal-body img').addClass("hidden");
  }
}

export default FileListController;



// WEBPACK FOOTER //
// ./client/app/pages/profile/component/fileList.controller.js